import { render, staticRenderFns } from "./EditProjectLinkModal.vue?vue&type=template&id=08ce1c3c&"
import script from "./EditProjectLinkModal.vue?vue&type=script&lang=js&"
export * from "./EditProjectLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports